export const PAGES = {
  LOGIN: "/login",
  RESET_PASSWORD: "/reset-password",
  SET_NEW_PASSWORD: "/set-new-password",
  ACCEPT_INVITATION: "/accept-invitation",

  HOME: "/",

  COMPANY_LIST: "/companies",
  COMPANY_DETAIL: "/companies/:id",
  PORTFOLIOS_LIST: "/portfolios",
  PORTFOLIO_DETAIL: "/portfolios/:id",
  ASSETS_LIST: "/assets",
  ASSET_DETAIL: "/assets/:id",
  ASSET_PARAMETER_BREAKDOWN: "/assets/:id/breakdown/:parameter",
  CHARTS: "/charts/:id",
  USERS: "/users",
  INCIDENTS_LIST: "/incidents",
  REPORTS: "/reports",
  DEVICES_LIST: "/devices",
  DEVICE_DETAIL: "/devices/:id",
  SETTINGS: "/settings",
  SETTINGS_NOTIFICATIONS: "/settings/notifications",
  SETTINGS_GATEWAYS_LIST: "/settings/gateways",
  SETTINGS_IAQ_LIMIT_SETTINGS: "/settings/iaq-limit-settings",

  ERROR: "/error",
  BAD_REQUEST: "/400",
  FORBIDDEN: "/403",
  NOT_FOUND: "/404",
  SERVER_ERROR: "/500",
};
